var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#848992",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 6.6a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.763 2.084l.49 1.656c.17.566.739.903 1.302.77l1.633-.39c.8-.186 1.596.33 1.776 1.153A1.56 1.56 0 0 1 35.6 6.65l-1.143 1.282a1.163 1.163 0 0 0 0 1.551l1.142 1.269a1.556 1.556 0 0 1-.078 2.157c-.36.342-.86.48-1.335.371l-1.628-.394a1.097 1.097 0 0 0-1.3.77l-.496 1.663c-.234.802-1.056 1.258-1.837 1.016a1.494 1.494 0 0 1-.989-1.016l-.49-1.656a1.098 1.098 0 0 0-1.302-.77l-1.633.39c-.801.183-1.595-.332-1.774-1.156a1.552 1.552 0 0 1 .36-1.372l1.143-1.269a1.163 1.163 0 0 0 0-1.55l-1.142-1.268a1.556 1.556 0 0 1 .074-2.157c.358-.345.86-.484 1.339-.373l1.633.39a1.098 1.098 0 0 0 1.301-.77l.49-1.674c.234-.802 1.052-1.26 1.834-1.02.478.145.85.529.993 1.02zM11.055 14.633a2.003 2.003 0 0 0 2.983 0l.972-1.07a2.012 2.012 0 0 1 3.5 1.451l-.073 1.439a2.013 2.013 0 0 0 2.112 2.111l1.436-.074a2.011 2.011 0 0 1 1.45 3.502l-1.068.966a2.001 2.001 0 0 0 0 2.984l1.068.966c.825.744.892 2.016.147 2.84-.405.45-.992.694-1.597.662l-1.436-.074a2.014 2.014 0 0 0-2.112 2.111l.073 1.439a2.009 2.009 0 0 1-3.5 1.45l-.966-1.069a2.003 2.003 0 0 0-2.983 0l-.978 1.07a2.01 2.01 0 0 1-3.5-1.451l.073-1.439a2.01 2.01 0 0 0-2.11-2.111l-1.438.074a2.01 2.01 0 0 1-1.444-3.498l1.068-.965a2.002 2.002 0 0 0 0-2.985l-1.068-.965a2.012 2.012 0 0 1 1.45-3.502l1.438.074a2.013 2.013 0 0 0 2.11-2.112l-.074-1.443a2.012 2.012 0 0 1 3.495-1.45l.972 1.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M12.55 19.2a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.85896f36600f2624f586af0ef95240cb.svg";
export { ForwardRef as ReactComponent };